import { render } from "./TripsTMS.vue?vue&type=template&id=0b92127d&scoped=true&ts=true"
import script from "./TripsTMS.vue?vue&type=script&lang=ts"
export * from "./TripsTMS.vue?vue&type=script&lang=ts"

import "./TripsTMS.vue?vue&type=style&index=0&id=0b92127d&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b92127d"]])

export default __exports__